import {CheckOutlined, CloseOutlined} from '@ant-design/icons'
import {Switch} from 'antd'
import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {BsShieldLockFill} from "react-icons/bs";
import {renderIf} from "../../../views/Shared";

const FieldDescription = ({children, className, title, description}) => {
    const t = useTranslate()
    return (
        <div className={className}>
            <div className="flex flex-col flex-1">
                {renderIf(
                    title,
                    <div className="font-bold text-base text-color-000 tracking-wider">{t(title)}</div>
                )}
                {renderIf(
                    description,
                    <div className="text-color-300 tracking-wider italic">{t(description)}</div>
                )}
            </div>
            {children}
        </div>
    )
}

export const ToggleField = ({
                                name,
                                title,
                                value,
                                disabled,
                                className,
                                onChange,
                                description,
                                defaultValue,
                                Wrapper = FieldDescription,
                            }) => (
    <Wrapper
        title={title}
        description={description}
        className={classNames(
            'flex items-start justify-start w-full space-x-3',
            className
        )}>
        {/* Switch PHẢI luôn controlled (checked={!!value}) - trước đây chỉ truyền `checked` khi
            value truthy, value=false thì Switch rơi về uncontrolled (tự quản state qua
            defaultChecked). Hậu quả thật: onChange chặn thay đổi (return sớm, không gọi API) nhưng
            Switch uncontrolled đã tự bật lên trên UI trước khi React kịp biết - value/is_enabled ở
            component cha vẫn false nhưng mắt thấy đã "bật", chỉ refresh trang (mount lại, đọc value
            thật từ server) mới thấy đúng lại là tắt - đúng lỗi đã gặp thực tế ở
            WorkspaceOrganizationFeatures.js. defaultValue bỏ hẳn vì vô nghĩa khi đã luôn controlled. */}
        <Switch
            disabled={disabled}
            onChange={onChange}
            checkedChildren={<CheckOutlined/>}
            unCheckedChildren={<CloseOutlined/>}
            checked={!!value}
        />
    </Wrapper>
)

export const CustomToggleField = ({
                                      title,
                                      className,
                                      description,
                                      Icon = BsShieldLockFill,
                                      ...props
                                  }) => {

    const t = useTranslate()

    const Wrapper = useMemo(() => {
        return ({children}) => (
            <div className="flex flex-col">
                <div className="w-full flex items-center">
                    <div className="flex flex-1 items-center gap-2">
                        <Icon size={16} className="text-secondary-400"/>
                        <span className="font-bold text-base text-secondary-600">{t(title)}</span>
                    </div>
                    {children}
                </div>
                {renderIf(
                    description,
                    <span className="ml-1 mt-1 text-color-300 tracking-wider leading-snug">
                        {t(description)}
                    </span>
                )}
            </div>
        )
    }, [t, title, description])

    return (
        <div className={className ? className : "p-3 border border-dashed border-secondary background rounded-xl"}>
            <ToggleField
                {...props}
                Wrapper={Wrapper}
            />
        </div>
    )
}
